import * as React from 'react'
import Spinner from '../../components/Spinner'
import moment from 'moment/min/moment-with-locales'
import { Redirect } from 'react-router-dom'
import { ScaleUploadImg } from '../../components/ScaleUploadImg'

class ManageEventDetailScreen extends React.Component {
  

  constructor(props) {
    super(props)
    moment.locale('pl');
    if( this.props.location.article ) {
      this.state = { ...this.props.location.article, date: moment(this.props.location.article.date.seconds*1000).format("YYYY-MM-DD") }
    } else {
      this.state = { title: '', date: moment().format("YYYY-MM-DD") }
    }
  }
    

  
  componentWillReceiveProps(nextProps) {
    const { message } = nextProps.app
    if( message.length>0 && message!=='{ok}' )
      setTimeout( () => { this.props.appMessage('') }, 6000)
    else if( message==='{ok}' ) {
      this.props.appMessage('')
      this.props.history.goBack()
    }
  }
  

  renderInput = ({ fieldName, value, label, date=false }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <input 
          type={date ? 'date' : 'text'} 
          className="form-control" 
          placeholder={label} 
          onChange={event=>this.setState({ [fieldName]: event.target.value })}
          defaultValue={value}
        />
      </div>
    )
  }

  renderTextarea = ({ fieldName, value, label }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <textarea 
          className="form-control"
          rows={10}
          placeholder={label} 
          onChange={event=>this.setState({ [fieldName]: event.target.value })}
          defaultValue={value ? value.replace(/<br\s*[/]?>( |)/gi, "\n") : ''} 
        ></textarea>
      </div>
    )
  }

  addOrUpdateEvent = () => {
    let eventObject = { ...this.state, date: moment(this.state.date).toDate() }
    if( this.state.id)
      this.props.updateEventData(eventObject)
    else
      this.props.addNewEvent(eventObject)
  }

  deleteEventWithAlert = () => {
    if (window.confirm('Potwierdź usunięcie Wydarzenia'))
      this.props.deleteEvent(this.state.id)
  }

  isDisabled() {
    const { description, title } = this.state

    if( !description || !description.length || !title || !title.length ) return true
    else return false
  }

  render() {
    if( !this.state ) return <Redirect to="/manageapp" />
    const { title, description, date, id, photo } = this.state
    if( this.props.app.loading ) return <Spinner />
    return (
      <div>
        { this.props.app.message.length>0 ? <div className="alert alert-danger">{this.props.app.message}</div> : null}

        <form>
          {this.renderInput({fieldName: 'title', value: title, label: 'Tytuł'})}
          {this.renderInput({fieldName: 'date', value: date, label: 'Data', date: true })}
          {this.renderTextarea({fieldName: 'description', value: description, label: 'Treść'})}


          <div className="my-3">
            <label className="w-100">Zdjęcie do wydarzenia</label>
            {photo && <img alt="" src={photo} /> }
            {photo && <img alt="" style={{ width: '50px' }} src={require('../../assets/rotate.png')} onClick={ () => this.resetOrientationHandler() } /> }
            <ScaleUploadImg maxHeight={300} maxWidth={300} onChangePhoto={ (photo) => this.setState({ photo }) } />
          </div>

          <button
            type="submit"
            className="btn btn-primary mt-2"
            disabled={ this.isDisabled() }
            onClick={ this.addOrUpdateEvent }
          >{id ? 'Aktualizuj' : 'Dodaj'}
          </button>
        </form>

        {id &&  <button
                  className="btn btn-danger mt-3 small"
                  disabled={ this.isDisabled() }
                  onClick={ this.deleteEventWithAlert }
                >Usuń Wydarzenie
                </button>
        }
      </div>
    )
  }
}


export default ManageEventDetailScreen



// WEBPACK FOOTER //
// ./src/screens/ManageEvents/ManageEventDetailScreen.js